import React, {useState} from 'react';
import {MdOutlineWhatsapp} from "react-icons/md";
import './lazywa.css';
import axiosInstance from "../../utils/axiosInstance";
import Trans from "../../locales/translations";
import {useLanguage} from "../../contexts/LanguageContext";

import {
    FaBirthdayCake,
    FaSun,
    FaMoon,
    FaHeart,
    FaRandom,
    FaCheck, FaMagic, FaRegCopy
} from 'react-icons/fa';
import {FaCopy} from "react-icons/fa6";
import {Button, Col, Row} from "react-bootstrap";
import {useUserContext} from "../../contexts/UserContext";

const Lazywa = () => {
    const [recipientName, setRecipientName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [occasion, setOccasion] = useState('birthday');
    const [personalTouch, setPersonalTouch] = useState('');
    const [message, setMessage] = useState('');
    const [originalMessage, setOriginalMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isWhacky, setIsWhacky] = useState(false);
    const [includePersonalTouch, setIncludePersonalTouch] = useState(false); // New state for checkbox
    const {language} = useLanguage();
    const {user} = useUserContext()
    const occasionOptions = [
        {value: 'birthday', label: <Trans k="lazywa.occasionOptions.birthday"/>, icon: <FaBirthdayCake/>},
        {value: 'loveYou', label: <Trans k="lazywa.occasionOptions.loveYou"/>, icon: <FaHeart/>},
        {value: 'goodMorning', label: <Trans k="lazywa.occasionOptions.goodMorning"/>, icon: <FaSun/>},
        {value: 'goodNight', label: <Trans k="lazywa.occasionOptions.goodNight"/>, icon: <FaMoon/>},
        {value: 'random', label: <Trans k="lazywa.occasionOptions.random"/>, icon: <FaRandom/>}
    ];

    const phonePlaceHolder = language === 'en' ? 'Phone Number' : 'מספר טלפון';
    const recipientNamePlaceHolder = language === 'en' ? 'Recipient Name' : 'שם נמען';
    const filteredOccasionOptions = isWhacky
        ? occasionOptions.filter(option => option.value === 'random')
        : occasionOptions.filter(option => option.value !== 'random');

    const handleGenerateMessage = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post('/lazywa/generate-message', {
                name: recipientName,
                occasion: occasion,
                language: language,
                includePersonalTouch: includePersonalTouch,
                phoneNumber: phoneNumber
            });
            setOriginalMessage(response.data.message);
            setMessage(response.data.message);
        } catch (error) {
            console.error('Error generating message:', error);
            setMessage('Failed to generate message.');
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateMessageWithPersonalTouch = () => {
        if (originalMessage.includes('{personalTouch}')) {
            const updatedMessage = originalMessage.replace('{personalTouch}', personalTouch);
            setMessage(updatedMessage);
        }
    };

    const handleSendWhatsAppMessage = async () => {
        const content = message
        const encodedMessage = encodeURIComponent(message);
        const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        try {
            // Save message to the database
            const userId =  user._id || 'generic'; // Replace with your user ID logic
            const payload = {
                content,
                phoneNumber,
                userId
            };

            await axiosInstance.post('messages/message', payload);
            console.log('Message saved successfully');

            // Open WhatsApp in a new tab
            window.open(url, '_blank');
        } catch (error) {
            console.error('Error saving message:', error);
        }
    };

    return (
        <div className={`lazywa-style`}>
            <div className="window">
                <div className="window-body">
                    {/*<h1 className="h1-glitch"><Trans k="lazywa.title" /></h1>*/}
                    <div className="input-container">
                        <input
                            placeholder={recipientNamePlaceHolder}
                            className="form-control"
                            type="text"
                            id="name"
                            value={recipientName}
                            onChange={(e) => setRecipientName(e.target.value)}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="phone"></label>
                        <input
                            placeholder={phonePlaceHolder}
                            className="form-control mb-3"
                            type="number"
                            id="phone"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            required={true}
                        />
                    </div>
                    <div className="input-container">
                        <div className="occasion-buttons">
                            {filteredOccasionOptions.map(option => (
                                <button
                                    key={option.value}
                                    className={`occasion-button ${occasion === option.value ? 'selected' : ''}`}
                                    onClick={() => setOccasion(option.value)}
                                >
                                    {option.icon}
                                    <span>{option.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="input-container">
                        <div className="checkbox-container">
                            <input
                                type="checkbox"
                                id="personalTouch"
                                checked={includePersonalTouch}
                                onChange={() => setIncludePersonalTouch(prev => !prev)}
                                className="custom-checkbox"
                            />
                            <label htmlFor="personalTouch" className="checkbox-label">
                                <span className="checkbox-icon"></span>
                                <span className="checkbox-text">Include Personal Touch</span>
                            </label>
                        </div>

                    </div>
                    <div className='d-flex justify-content-center'>
                        <Button className='my-2 generate-button' onClick={handleGenerateMessage} disabled={loading}>
                            {loading ? <Trans k="lazywa.generating"/> :
                                <div><FaMagic className='me-3'/><Trans k="lazywa.generate"/></div>}
                        </Button>
                    </div>
                    {message && (
                        <div className='result-container'>
                            {loading && (
                                <div className="loading-bar">
                                    <div className="spinner-border"></div>
                                </div>
                            )}
                            {message && (
                                <>
                                    {originalMessage.includes('{personalTouch}') && includePersonalTouch && (
                                        <div className="input-container">
                                            <div className='d-flex'>
                                                <input
                                                    placeholder="Add your personal touch"
                                                    type="text"
                                                    id="personalTouch"
                                                    value={personalTouch}
                                                    onChange={(e) => setPersonalTouch(e.target.value)}
                                                />
                                                <button className="btn-primary"
                                                        onClick={handleUpdateMessageWithPersonalTouch}><FaCheck/>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    <p className="message-output">{message}</p>
                                    <Row className='justify-content-center'>
                                        <Col xs={10} className=''>
                                            <Button
                                                variant='success'
                                                onClick={handleSendWhatsAppMessage}
                                                className='w-100'
                                            >
                                                <MdOutlineWhatsapp size={25}/>
                                            </Button>
                                        </Col>
                                        <Col xs={2} className='p-0'>
                                            <Button
                                                onClick={() => navigator.clipboard.writeText(message)}
                                                className='btn-copy'
                                            >
                                                <FaRegCopy size={25}/>
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Lazywa;
